import React from 'react';
import { Box, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { QuestionType } from '../CampaignQuestionsEditor/types';

interface QuestionTestInputProps {
    questionType: QuestionType;
    testValue: string | number;
    onTestValueChange: (value: string) => void;
}

/**
 * Displays a test input overlay for a question chip.
 *  *
 * @param {QuestionTestInputProps} props
 * @returns {JSX.Element}
 */
const QuestionTestInput: React.FC<QuestionTestInputProps> = ({ questionType, testValue, onTestValueChange }) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        const value = e.target.value;
        // Allow empty string, numbers, decimal point, and minus sign
        // This regex allows: optional minus, digits, optional decimal point with digits
        if (value === '' || /^-?\d*\.?\d*$/.test(value)) {
            onTestValueChange(value);
        }
    };

    const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        onTestValueChange(e.target.checked ? '1' : '0');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '60px',
            }}
        >
            {questionType === QuestionType.BOOLEAN && (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={testValue === 1 || testValue === '1'}
                            onChange={handleToggleChange}
                            onClick={(e) => e.stopPropagation()}
                            size="small"
                        />
                    }
                    label=""
                    onClick={(e) => e.stopPropagation()}
                    sx={{ margin: 0, alignItems: 'center', gap: 0.25 }}
                />
            )}
            {questionType === QuestionType.NUMERIC && (
                <TextField
                    value={testValue}
                    onChange={handleInputChange}
                    onClick={(e) => e.stopPropagation()}
                    type="text"
                    size="small"
                    placeholder="0"
                    sx={{
                        width: '40px',
                        '& .MuiInputBase-root': {
                            fontSize: '0.875rem',
                        },
                        '& .MuiInputBase-input': {
                            py: 0.5,
                            px: 0.25,
                            textAlign: 'center',
                        },
                    }}
                />
            )}
        </Box>
    );
};

export default QuestionTestInput;
